'use client'

import { useRouter } from 'next/navigation'
import { useContext, useEffect, useRef, useState } from 'react'

import {
  AppReadScopeContext,
  AppRefreshContext,
} from '@/features/veluvit/hooks/use-app-read-scope'
import { sessionAccessKey } from '@/features/veluvit/lib/app-read'
import { useSessionStore } from '@/features/veluvit/stores/session.store'

import type { ReactNode } from 'react'

type Props = {
  epoch: string
  owner?: string | null
  access?: string
  children: ReactNode
}

export default function PageReadScope({
  epoch,
  owner,
  access: expectedAccess,
  children,
}: Props) {
  const router = useRouter()
  const requestRefresh = useContext(AppRefreshContext)
  const refreshed = useRef(false)
  const identity = useSessionStore((state) => state.identity)
  const actualOwner = useSessionStore((state) => state.data?.user?.id ?? null)
  const access = useSessionStore((state) => sessionAccessKey(state.data))
  const [scope] = useState(() => ({ epoch, identity, access }))
  const current =
    (owner === undefined || actualOwner === owner) &&
    (expectedAccess === undefined || expectedAccess === access)
  useEffect(() => {
    if (current || refreshed.current) return
    refreshed.current = true
    if (requestRefresh) requestRefresh()
    else router.refresh()
  }, [current, requestRefresh, router])
  return (
    <AppReadScopeContext.Provider value={current ? scope : null}>
      {children}
    </AppReadScopeContext.Provider>
  )
}
